module.exports = __webpack_public_path__ + "media/stylesheets/images/main/sample184x190-90020c17401cb9c031a0160a33984780.jpeg";